import React from 'react'
import { SongwriterSummary } from '@Entities/songwriter/songwriter-summary'
import AccountCard from '@Components/Cards/AccountCard'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'

interface SongwriterCardProps {
    songwriterData: SongwriterSummary
    openPopup?(): void
    viewDetails?: boolean
}

export const SongwriterAccountCard = (props: SongwriterCardProps) => {
    const { songwriterData, openPopup, viewDetails = true } = props
    return (
        <AccountCard
            name={songwriterData.name}
            totalWorks={songwriterData.totalWorks}
            id={songwriterData.id}
            deleteButton
            isValidationStatusWrong={false}
            openPopup={openPopup}
            viewDetails={viewDetails}
            link={Navigation.songwriter.catalog.root(songwriterData.id)}
            icon={ICONS.songwriterHub}
            blueImageFilter={false}
            countType="songs"
        />
    )
}
export default SongwriterAccountCard
